class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.trigger = this.querySelector('.header__menu-item-summary');
    this.menuLink = this.querySelector('a.header__menu-item');
    this.toggleButton = this.querySelector('.header__submenu-toggle');
    this.content =
      this.querySelector('.mega-menu__content') ||
      this.querySelector('.header__submenu-wrapper') ||
      this.querySelector('.header__submenu');

    this.toggleButton?.addEventListener('click', this.onToggleButtonClick.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') {
        this.close();
        (this.toggleButton || this.menuLink)?.focus();
      }
    });
  }

  get open() {
    return this.hasAttribute('open');
  }

  set open(value) {
    if (value) {
      this.setAttribute('open', '');
    } else {
      this.removeAttribute('open');
    }

    this.syncExpandedState();
    this.onOpenChange();
  }

  onToggleButtonClick(event) {
    event.preventDefault();
    event.stopPropagation();
    this.open = !this.open;
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  syncExpandedState() {
    const expanded = this.open ? 'true' : 'false';
    this.toggleButton?.setAttribute('aria-expanded', expanded);

    if (this.toggleButton) {
      const label = this.open
        ? this.toggleButton.dataset.closeLabel
        : this.toggleButton.dataset.openLabel;

      if (label) this.toggleButton.setAttribute('aria-label', label);
    }

    if (this.content) {
      this.content.hidden = !this.open;
    }
  }

  onOpenChange() {
    if (!this.content) return;

    if (!this.animations) this.animations = this.content.getAnimations?.() || [];

    if (this.open) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }

    if (!this.header) return;
    this.header.preventHide = this.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  close() {
    this.open = false;
  }
}

customElements.define('header-menu', HeaderMenu);
